import { Suspense } from 'components/common/Suspense/index.js';
import {
  AccountPage,
  AccountsPage,
} from 'features/organization/index.js';
import {
  ActionsPage,
  CompaniesPage,
  CompanyViewPage,
  RegistryAdminListPage,
  UsersPage,
  UserViewPage,
} from 'features/registry-admin/index.js';
import {
  HoldingsPage,
  UnitPage,
} from 'features/units/index.js';
import {
  Navigate,
  Route,
} from 'react-router';
import { RoutePaths } from 'shared/routes.js';
import { asLazy } from 'shared/utils/lazy.utils.js';

import { useCreateRegistryAdminNavigationMenu } from '../utils/navigationMenu.js';
import { useRoutesRootElement } from './useRoutesRootElement.js';

const LogsPage = asLazy(import('../../pages/logs/LogsPage.js'), 'LogsPage');
const ProfileSettingsPage = asLazy(
  import('../../pages/profile-settings/ProfileSettingsPage.js'),
  'ProfileSettingsPage',
);

export const useRegistryAdminRoutes = () => {
  const navigationItems = useCreateRegistryAdminNavigationMenu();
  const renderRootElement = useRoutesRootElement();

  return (
    <Route path="/" element={renderRootElement(navigationItems)}>
      <Route
        path={RoutePaths.COMPANY}
        element={(
          <Suspense>
            <RegistryAdminListPage />
          </Suspense>
        )}
      />
      <Route
        path={RoutePaths.COMPANIES}
        element={(
          <Suspense>
            <CompaniesPage />
          </Suspense>
        )}
      />
      <Route
        path={RoutePaths.COMPANY_VIEW()}
        element={(
          <Suspense>
            <CompanyViewPage />
          </Suspense>
        )}
      />
      <Route
        path={RoutePaths.ACCOUNTS}
        element={(
          <Suspense>
            <AccountsPage />
          </Suspense>
        )}
      />
      <Route
        path={RoutePaths.ACCOUNT()}
        element={(
          <Suspense>
            <AccountPage />
          </Suspense>
        )}
      />
      <Route
        path={RoutePaths.USERS}
        element={(
          <Suspense>
            <UsersPage />
          </Suspense>
        )}
      />
      <Route
        path={RoutePaths.USER_VIEW()}
        element={(
          <Suspense>
            <UserViewPage />
          </Suspense>
        )}
      />
      <Route
        path={RoutePaths.ACTIONS}
        element={(
          <Suspense>
            <ActionsPage />
          </Suspense>
        )}
      />
      <Route
        path={RoutePaths.LOGS}
        element={(
          <Suspense>
            <LogsPage />
          </Suspense>
        )}
      />
      <Route
        path={RoutePaths.PROFILE_SETTINGS}
        element={(
          <Suspense>
            <ProfileSettingsPage />
          </Suspense>
        )}
      />
      <Route
        path={RoutePaths.HOLDINGS}
        element={(
          <Suspense>
            <HoldingsPage />
          </Suspense>
        )}
      />
      <Route
        path={RoutePaths.UNIT_VIEW()}
        element={(
          <Suspense>
            <UnitPage />
          </Suspense>
        )}
      />

      <Route path="/" element={<Navigate to={RoutePaths.COMPANY} />} />
    </Route>
  );
};
